import React from "react";
import styled, { css } from "styled-components";
import isNil from "lodash/isNil";
import { camelCase } from "lodash";
import { Typography } from "@mui/material";

interface BaseStatusCircleProps {
  status: string;
  text: string;
  className?: string;
  profileHeader?: boolean;
}

const BaseStatusCircle: React.FC<BaseStatusCircleProps> = ({
  status,
  text,
  className,
  profileHeader,
}) => (
  <StatusCircleContainer
    className={className}
    status={status}
    profileHeader={profileHeader}
  >
    <span className="status-circle" aria-label="status-circle" />
    {!isNil(text) && (
      <Typography
        component={"span"}
        className="status-text"
        style={{ fontSize: profileHeader ? "14px" : "body1" }}
        data-private="true"
      >
        {text}
      </Typography>
    )}
  </StatusCircleContainer>
);

export const StatusCircleContainer = styled.span<{
  status: string;
  profileHeader?: boolean;
}>`
  .status-circle {
    display: inline-block;
    border-radius: 50%;
    max-width: 10px;
    max-height: 10px;
    width: 10px;
    height: 10px;
  }

  ${({ theme, status }) => {
    const colour = theme[camelCase(status)];

    if (colour) {
      return css`
        .status-circle {
          background-color: ${colour};
        }
      `;
    }

    return css`
      .status-circle {
        display: none;
      }
      span.status-text {
        margin-left: 0;
      }
    `;
  }}
`;

export const StatusCircle = styled(BaseStatusCircle)`
  white-space: nowrap;
  .status-text {
    margin-left: ${(props) => props.theme.spacingUnit}px;
  }
`;

export default StatusCircle;
